import React from 'react';
import { Link } from 'react-router-dom';

export default function SupportSection({ slug, hasFAQs }) {
  return (
    <div style={{
      width: '100%',
      minHeight: '300px',
      backgroundColor: '#000000',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px 16px',
      position: 'relative',
      overflow: 'hidden',
      borderTop: '1px solid #1a1a1a',
    }}>
      {/* Light flare — off-center warm bloom */}
      <div style={{
        position: 'absolute',
        top: '30%',
        left: '65%',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(200, 150, 80, 0.1) 0%, rgba(200, 150, 80, 0.03) 40%, transparent 70%)',
        pointerEvents: 'none',
        transform: 'translate(-50%, -50%)',
      }} />
      <div style={{
        position: 'absolute',
        top: '60%',
        left: '25%',
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, rgba(100, 130, 200, 0.07) 0%, rgba(100, 130, 200, 0.02) 40%, transparent 70%)',
        pointerEvents: 'none',
        transform: 'translate(-50%, -50%)',
      }} />
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        alignItems: 'center',
        position: 'relative',
      }}>
        <h2 style={{
          fontSize: '2rem',
          fontWeight: 800,
          fontFamily: 'Helvetica, Arial, sans-serif',
          color: '#ffffff',
          margin: 0,
          letterSpacing: '-0.05em',
          lineHeight: 1.2,
          textAlign: 'center',
        }}>
          Support & Information
        </h2>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '32px',
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}>
          {hasFAQs && (
            <Link
              to={`/${slug}/help`}
              style={{
                color: '#ffffff',
                textDecoration: 'underline',
                textUnderlineOffset: '4px',
                fontSize: '1rem',
                fontWeight: 500,
                transition: 'opacity 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = '0.6';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = '1';
              }}
            >
              Get Support
            </Link>
          )}
          <Link
            to={`/privacy`}
            style={{
              color: '#ffffff',
              textDecoration: 'underline',
              textUnderlineOffset: '4px',
              fontSize: '1rem',
              fontWeight: 500,
              transition: 'opacity 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = '0.6';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = '1';
            }}
          >
            Privacy Policy
          </Link>
          <Link
            to={`/terms`}
            style={{
              color: '#ffffff',
              textDecoration: 'underline',
              textUnderlineOffset: '4px',
              fontSize: '1rem',
              fontWeight: 500,
              transition: 'opacity 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = '0.6';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = '1';
            }}
          >
            Terms of Service
          </Link>
        </div>
      </div>
    </div>
  );
}
